import { breaks } from '../../const/mediaQueries';
const setMediaQueryStyles = (key, style, queryType = 'min') => {
    return `@media (${queryType}-width: ${breaks[key]}) { ${style} }`;
};
export default setMediaQueryStyles;
